import { render, staticRenderFns } from "./TokenHolderTable.vue?vue&type=template&id=6a889594&scoped=true"
import script from "./TokenHolderTable.vue?vue&type=script&lang=js"
export * from "./TokenHolderTable.vue?vue&type=script&lang=js"
import style0 from "./TokenHolderTable.vue?vue&type=style&index=0&id=6a889594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a889594",
  null
  
)

export default component.exports